import CollateralsList from "./CollateralsList";

export default CollateralsList;
